import { render, staticRenderFns } from "./BlockType25.vue?vue&type=template&id=2809754d&scoped=true"
import script from "./BlockType25.vue?vue&type=script&lang=ts"
export * from "./BlockType25.vue?vue&type=script&lang=ts"
import style0 from "./BlockType25.vue?vue&type=style&index=0&id=2809754d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2809754d",
  null
  
)

export default component.exports